<template>
  <v-dialog
    width="600px"
    v-model="showDialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-large
        text
        @click="showDialog = true"
        class="mb-4 ignoredisableall"
        v-bind="attrs"
        v-on="on"
      >
        <eva-icon
          class="patient-create__icon mr-2"
          name="slash-outline"
        />
        {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
      </v-btn>
    </template>

    <div class="dashboard-dialog-window">
      <div class="dashboard-dialog-window__message">
        {{ $ucfirst($t('patient.areYouSureToCancelPatientCreation')) }}
      </div>
      <div class="dashboard-dialog-window__actions">
        <v-btn
          x-large
          text
          class="ml-4"
          @click="confirm"
        >
          {{ $ucfirst($t('confirm')) }}
        </v-btn>
        <v-btn
          x-large
          text
          class="ml-4"
          @click="showDialog = false"
          color="primary"
        >
          {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import RouterHistory from '../../../../router/hooks/router-history';

/**
 * Component PatientCreateCloseButton.vue
 *
 * @module PatientCreateCloseButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.2] app/src/APP_DASHBOARD/templates/views/Patient/Create/PatientCreateCloseButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientCreateCloseButton',
  data() {
    return {
      showDialog: false,
      prevRoute: null
    };
  },
  methods: {
    confirm() {
      RouterHistory.back(1, '/alerts')
    },
  },
}
</script>
